import { createSlice } from '@reduxjs/toolkit';

const LoginSlice = createSlice({
  name: 'login',
  initialState: {
    userDetails: window && localStorage.getItem("user") !== null?JSON.parse(localStorage.getItem("user")):null
  },
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    }
  }
});

export const { setUserDetails } = LoginSlice.actions;
export default LoginSlice.reducer;